module.exports = __webpack_public_path__ + "img/위험도_팝업.a0be78ae.png";